module.exports = __webpack_public_path__ + "img/activityTitle1.ac27f1b.png";